import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@fluentui/react-components';
import { UserLabel } from '@modules/users';
import { Dispatch, SetStateAction } from 'react';

/**
 * Dialog state for LockedUsersDialog
 */
export type TLockedUsersDialogState = {
  isOpen: boolean;
  userIds: string[];
};

/**
 * Props for LockedUsersDialog following state/setState pattern
 */
type TLockedUsersDialogProps = {
  state: TLockedUsersDialogState;
  setState: Dispatch<SetStateAction<TLockedUsersDialogState>>;
};

/**
 * Displays a list of users blocking the selected documents
 */
const LockedUsersDialog = ({ state, setState }: TLockedUsersDialogProps) => {
  const { isOpen, userIds } = state;

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(_, data) => {
        setState({ ...state, isOpen: data.open });
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Documents locked</DialogTitle>
          <DialogContent className="space-y-4">
            <p>The following users have locked one or more documents:</p>
            <ul className="list-none space-y-2">
              {userIds.map((id) => (
                <li key={id}>
                  <UserLabel id={id} avatarProps={{ size: 24 }} textProps={{ as: 'span' }} />
                </li>
              ))}
            </ul>
            <p className="mt-4">Please try again later.</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setState({ ...state, isOpen: false })}>Close</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default LockedUsersDialog;
